<script setup lang="ts">
import { useQuery } from '@tanstack/vue-query';
import { onMounted } from 'vue';
import { useCommonInfoService } from '@/entities/Services/CommonInfo/CommonInfoService';
import { useContactsStore } from '@/entities/Stores/Contacts';
import { useFlowController } from '@/features/flow/Flow';
import { B2SNewBanner, useIsB2SActive } from '@/features/New-B2S';
import { useFlowLoadingEmitter } from '@/shared/composables';
import { ErrorWidget } from '@/widgets/ErrorWidget';
import { FlowWidget } from '@/widgets/FlowWidget';
import { LoaderWidget } from '@/widgets/LoaderWidget';

const { handleOnBack, error, resolveError, loading, onLoading, landingUrl } = useFlowController();
const { isB2SActive } = useIsB2SActive();
const emitLoading = useFlowLoadingEmitter();
const commonInfoService = useCommonInfoService();
const contactsStore = useContactsStore();

const { refetch: fetchContacts } = useQuery({
  queryKey: ['contacts'],
  queryFn: () => commonInfoService.fetchContacts(),
  enabled: false,
});

onMounted(async () => {
  if (contactsStore.contacts.length) {
    return;
  }
  emitLoading(async () => {
    const { data } = await fetchContacts();
    contactsStore.contacts = Object.values(data ?? {});
  });
});
</script>

<template>
  <div id="download-banner-container" />
  <B2SNewBanner v-if="isB2SActive && !loading && !error" />
  <FlowWidget :landing-url="landingUrl" @go-back="handleOnBack">
    <ErrorWidget v-if="error" :error="error" @resolve="resolveError" />
    <template v-else>
      <LoaderWidget v-show="loading" />
      <RouterView v-show="!loading" @load="onLoading" />
    </template>
  </FlowWidget>
</template>
